import { googleCalendarLink, outlookCalendarLink, type CalendarMeeting } from '../lib/calendarLinks';
import { Icon } from '../lib/icons';

/**
 * "Add to calendar" (1.13.0, Teampace 2709): Google Calendar, Outlook (work or personal) or the
 * .ics file, for anyone with a meeting's time: the company's people and guests alike.
 */
export function AddToCalendar({ m, ics, dark }: { m: CalendarMeeting; ics: string; dark?: boolean }) {
  return (
    <details className={`add-to-calendar${dark ? ' dark' : ''}`}>
      <summary className="btn secondary">
        <Icon name="clock" size={17} strokeWidth={2.2} />
        Add to calendar
      </summary>
      <ul role="list">
        <li>
          <a href={googleCalendarLink(m)} target="_blank" rel="noopener noreferrer">
            Google Calendar
          </a>
        </li>
        <li>
          <a href={outlookCalendarLink(m)} target="_blank" rel="noopener noreferrer">
            Outlook (work or school)
          </a>
        </li>
        <li>
          <a href={outlookCalendarLink(m, true)} target="_blank" rel="noopener noreferrer">
            Outlook.com
          </a>
        </li>
        <li>
          <a href={ics} download>
            Apple Calendar, or any other (.ics file)
          </a>
        </li>
      </ul>
    </details>
  );
}
